import React, { useEffect, useState } from "react";
import { useHistory, Redirect } from "react-router-dom";

import {
  makeStyles,
  Grid,
  Container,
  Paper,
  Typography,
  Button,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

import { getMyNfts } from "../apiFunctions";

const useStyles = makeStyles((theme) => ({
  paperLoadingContainer: {
    borderRadius: theme.spacing(2),
    width: "100%",
    height: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  paperContainer: {
    borderRadius: theme.spacing(2),
    width: "100%",
    height: "100%",
    padding: theme.spacing(2),
    display: "flex",
    flexFlow: "column",
    justifyContent: "space-between",
  },

  imageBox: {
    width: "100%",
    height: "260px",
    marginBottom: theme.spacing(1),
  },

  skeletonImage: {
    borderRadius: theme.spacing(1),
  },

  nftImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: theme.spacing(1),
  },
}));

function MyNFTs({ network }) {
  const history = useHistory();
  const classes = useStyles();
  const [myNFTList, setMyNFTList] = useState([]);
  const [loading, setLoading] = useState(true);

  const get_nft_list = async () => {
    // start loading
    setLoading(true);

    let content = {
      account: network.account,
      chainID: network.chainID,
    };
    await getMyNfts(content).then((res) => {
      if (res) {
        setMyNFTList(res);
      }
    });

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    const myNFTTimeout = setTimeout(() => {
      if (network.stacking) {
        get_nft_list();
      }
    }, 1000);
    return () => clearTimeout(myNFTTimeout);
  }, []);

  return (
    <>
      {network.chainID != 56 ? (
        <div id="nft-pools">
          <Container maxWidth="xl">
            <Typography variant="h6" className="mb-4">
              My NFTs
            </Typography>

            {(!myNFTList.length || loading) && (
              <Grid container>
                <Paper elevation={0} className={classes.paperLoadingContainer}>
                  {loading ? "Loading..." : "No NFT To Show"}
                </Paper>
              </Grid>
            )}

            <Grid container spacing={2}>
              {myNFTList.map((item) => (
                <Grid
                  key={`${item.token_address}_${item.token_id}`}
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                >
                  <Paper
                    elevation={0}
                    className={classes.paperContainer}
                    key={item.token_id}
                  >
                    <div>
                      <div className={classes.imageBox}>
                        {!item?.metadata?.image ? (
                          <Skeleton
                            variant="rect"
                            height="100%"
                            className={classes.skeletonImage}
                          />
                        ) : (
                          <img
                            src={item?.metadata?.image}
                            alt={item?.metadata?.name || "nft"}
                            className={classes.nftImage}
                          />
                        )}
                      </div>
                      <Typography variant="body1" className="fw-bold">
                        {item.metadata?.name || item.name}
                      </Typography>
                    </div>
                    <div className="d-flex flex-column">
                      <Typography variant="caption">
                        #{item.token_id}
                      </Typography>

                      <Button
                        elevation={0}
                        variant="contained"
                        color="primary"
                        className="mt-4"
                        onClick={() =>
                          history.push(
                            `/my-nfts-detail/${item.token_address}/${item.token_id}`
                          )
                        }
                      >
                        Choose
                      </Button>
                    </div>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Container>
        </div>
      ) : (
        <Redirect to="/invest" />
      )}
    </>
  );
}

export default MyNFTs;
